import {
  NODE_HEIGHT,
  NODE_WIDTH
} from './constants.js';
import {
  setStatus,
  updateOverlay
} from './dom.js';

export function createDiagramInteractionHandlers({
  canvas,
  wrapper,
  statusChip,
  overlay,
  overlayTitle,
  overlayDesc,
  overlayTag,
  state
}) {
  const idleStatus = statusChip?.textContent.trim() || 'System Ready';
  const overlayTargets = {
    canvas,
    overlay,
    overlayTitle,
    overlayDesc,
    overlayTag
  };

  const nodeAtEvent = event => {
    const rect = canvas.getBoundingClientRect();
    const x = (event.clientX - rect.left - state.offset.x) / state.scale;
    const y = (event.clientY - rect.top - state.offset.y) / state.scale;

    return state.displayNodes.find(node => (
      x > node.x - (NODE_WIDTH / 2) &&
      x < node.x + (NODE_WIDTH / 2) &&
      y > node.y - (NODE_HEIGHT / 2) &&
      y < node.y + (NODE_HEIGHT / 2)
    )) || null;
  };

  const selectNode = (node, event) => {
    state.selectedNode = node;
    state.hoveredNode = node;
    updateOverlay({ ...overlayTargets, event, node, selected: true });
    setStatus(statusChip, node ? `Selected ${node.phase || 'Step'}` : idleStatus, Boolean(node));
  };

  const clearSelection = (event) => {
    state.selectedNode = null;
    updateOverlay({ ...overlayTargets, event, node: null });
    setStatus(statusChip, idleStatus, false);
  };

  const handleMouseDown = event => {
    state.isDragging = true;
    state.hasUserMovedViewport = true;
    state.lastMouse = { x: event.clientX, y: event.clientY };
    setStatus(statusChip, 'Moving Viewport', true);
  };

  const handleMouseMove = event => {
    if (state.isDragging) {
      state.offset.x += event.clientX - state.lastMouse.x;
      state.offset.y += event.clientY - state.lastMouse.y;
      state.lastMouse = { x: event.clientX, y: event.clientY };
    }

    const found = nodeAtEvent(event);
    if (found === state.hoveredNode) return;

    state.hoveredNode = found;
    if (!state.selectedNode) {
      updateOverlay({ ...overlayTargets, event, node: found });
    }
    setStatus(statusChip, found ? `Viewing ${found.phase || 'Details'}` : idleStatus, Boolean(found));
    wrapper.style.cursor = found ? 'pointer' : (state.isDragging ? 'grabbing' : 'grab');
  };

  const handleClick = event => {
    if (state.isDragging) return;

    const found = nodeAtEvent(event);
    if (found) {
      selectNode(found, event);
      return;
    }

    clearSelection(event);
  };

  const handleKeyDown = event => {
    if (event.key !== 'Escape') return;

    clearSelection(event);
  };

  const handleMouseUp = () => {
    state.isDragging = false;
    if (!state.hoveredNode) setStatus(statusChip, idleStatus, false);
  };

  return {
    handleClick,
    handleKeyDown,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp
  };
}
